class SearchDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.load()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'drawerClosed', this.onDrawerClose.bind(this))
    this.listeners.add(document, 'drawerOpen', this.onDrawerOpen.bind(this))
    this.listeners.add(
      this.els.searchField.element,
      'keyup',
      this.onSearchInputPopulation.bind(this),
    )

    window.addEventListener('klevuSuggestionsFetched', () => {
      this.els.suggestionValue.elements.forEach(element => {
        this.listeners.add(element, 'click', this.onSuggestion.bind(this))
      })
    })

    this.listeners.add(
      this.els.searchField.element,
      'keydown',
      this.onSearchSubmission.bind(this),
    )

    if (window.sessionStorage.getItem('lastSearch')) {
      this.els.searchField.element.value = window.sessionStorage.getItem(
        'lastSearch',
      )
      this.els.searchField.element.dispatchEvent(new KeyboardEvent('keyup'))
    }
  }

  load () {
    const queryParams = new URLSearchParams(window.location.search)

    if (queryParams.has('q')) {
      this.els.searchField.element.focus()

      this.listeners.add(
        this.els.searchField.element,
        'focus',
        this.onSearchInputPopulation.bind(this),
      )
    }
  }

  onSuggestion (event) {
    this.els.searchField.element.value = event.target.dataset.value
    this.els.searchField.element.focus()

    this.els.searchField.element.dispatchEvent(new KeyboardEvent('keyup'))
  }

  onSearchInputPopulation (event) {
    event.target.value.length > 0
      ? (this.els.overlayUI.element.style.display = 'none')
      : (this.els.overlayUI.element.style.display = 'block')
    window.sessionStorage.setItem(
      'lastSearch',
      this.els.searchField.element.value,
    )
  }

  onSearchSubmission (event) {
    if (event.key !== 'Enter') return
    event.preventDefault()
    if (event.target.value.length > 2) {
      document
        .querySelector('.drw-Drawer[key="search"]')
        .classList.add('drw-Drawer-fullscreen')
    }
  }

  onDrawerOpen (event) {
    if (event.detail.key !== 'search') return
    setTimeout(() => {
      this.els.searchField.element.focus()
    }, 1000)
  }

  onDrawerClose (event) {
    if (event.detail.key !== 'search') return

    // this.clearInputField(this.els.searchField.element)
    this.resetDrawerDOM()
  }

  /**
   * @param {HTMLFormElement} input
   */
  clearInputField (input) {
    input.value = ''
  }

  resetDrawerDOM () {
    document
      .querySelector('.drw-Drawer[key="search"]')
      .classList.remove('drw-Drawer-fullscreen')
    this.els.overlayUI.element.style.display = 'block'
  }
}

if (!customElements.get('search-drawer')) {
  customElements.define('search-drawer', SearchDrawer)
}
